module.exports = __webpack_public_path__ + "static/media/BANNER - Sign up_V6.7d8ddde8.jpg";